export default __webpack_public_path__ + "static/media/art-example.640099fb.png";